import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
function Contact (){

    return(<>
    
    <body style={{textAlign: 'center'}}className={'trade-body bg-zinc-950'}>
    <div style={{ color: 'red' ,height:'50px' ,paddingTop:"10px", paddingRight:"10px", transform: "scale(2.8)"}} className="svg_icons"><ForwardToInboxIcon/></div>
        <h1 style={{color:'white'}} className='mt-10 font-palanquin mobile-font text-8xl max-sm:text-[72px] font-bold'>
          <span style={{color:'white'}}className='xl:whitespace-nowrap relative z-10 pr-10'>
            Contact:
          </span>
          <br />
          <span className='text-cyan-300 text-coral-red inline-block mt-3'>leonsiawl@gmail</span><span style={{color:'white'}} className='text-coral-red inline-block mt-3'>.com</span>
        </h1>
    </body>
    </>)
}

export default Contact